import React from 'react';

const WINDOWS = [7, 30, 90];

/** The 7d / 30d / 90d window picker shared by the admin usage tabs. */
export const WindowToggle: React.FC<{ days: number; onChange: (days: number) => void }> = ({
  days,
  onChange,
}) => (
  <div
    className="flex items-center gap-1 bg-neutral-100 rounded-full p-1"
    role="group"
    aria-label="Usage window"
  >
    {WINDOWS.map((w) => (
      <button
        key={w}
        type="button"
        onClick={() => onChange(w)}
        aria-pressed={days === w}
        className={`px-3 py-1 rounded-full text-sm font-medium transition ${
          days === w
            ? 'bg-white text-primary-700 shadow-card'
            : 'text-neutral-500 hover:text-neutral-800'
        }`}
      >
        {w}d
      </button>
    ))}
  </div>
);
